// ultah.view — tab 🎂 Ulang Tahun di menu CRM.
//
// Dipisah dari daftar pelanggan (permintaan Apo): mengucapkan selamat adalah pekerjaan harian
// yang berdiri sendiri — buka tab, lihat siapa yang ulang tahun hari ini, kirim, selesai.
import { esc, wa62, fillTpl, todayISO } from '@domain/format';
import { waTpl } from '@core/settings';
import { openWA } from '@core/wa';
import { openModal } from '@ui/modal';
import * as repo from './crm.repo';
import * as afRepo from './afiliasi.repo';
import * as loyaltyRepo from './loyalty.repo';
import * as svc from './crm.service';

const BLN = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

let utBulan = new Date().getMonth() + 1;   // 1..12

interface BarisUt { id: number; nama: string; wa: string | null; tgl: number; poin: number; hariIni: boolean; besok: boolean }

export async function renderUltahTab(host: HTMLElement): Promise<void> {
  host.innerHTML = '<div class="panel"><div class="empty">Memuat…</div></div>';
  let custs: repo.CrmCustomer[], spend: Map<number, repo.Spend>, redeemed: Map<number, number>, grants: Map<number, afRepo.Grant[]>;
  try {
    [custs, spend, redeemed, grants] = await Promise.all([
      repo.listCustomers(), repo.spendByCustomer(), repo.redeemedByCustomer(), afRepo.grantsAktifSemua(),
    ]);
  } catch (e) { host.innerHTML = `<div class="panel err">${esc((e as Error).message)}</div>`; return; }

  const hari = todayISO();
  const tglHariIni = +hari.slice(8, 10), blnHariIni = +hari.slice(5, 7);

  const rows: BarisUt[] = custs
    .filter((c) => c.lahir && +c.lahir.slice(5, 7) === utBulan)
    .map((c) => {
      const s = spend.get(c.id) ?? { ltv: 0, trx: 0, last: null, per: [] };
      const g = (grants.get(c.id) ?? []).map((x) => ({ id: x.id, tgl: x.tgl, poin: x.poin, alasan: x.alasan, ditarik: !!x.ditarik_at, berlakuBulan: x.berlaku_bulan }));
      const tgl = +(c.lahir as string).slice(8, 10);
      return {
        id: c.id, nama: c.nama, wa: c.wa, tgl,
        poin: svc.saldo(s.per, redeemed.get(c.id) ?? 0, undefined, g).tersedia,
        hariIni: utBulan === blnHariIni && tgl === tglHariIni,
        besok: utBulan === blnHariIni && tgl === tglHariIni + 1,
      };
    })
    .sort((a, b) => a.tgl - b.tgl);

  const hariIni = rows.filter((r) => r.hariIni);
  const body = rows.map((r) => `<tr${r.hariIni ? ' style="background:var(--okbg)"' : ''}>
      <td style="white-space:nowrap"><b>${r.tgl}</b> ${esc(BLN[utBulan - 1] ?? '')}${r.hariIni ? ' <span class="pill" style="background:var(--ok);color:#fff">HARI INI</span>' : (r.besok ? ' <span class="pill" style="background:var(--warnbg);color:var(--warn)">besok</span>' : '')}</td>
      <td><b>${esc(r.nama)}</b></td>
      <td>${esc(wa62(r.wa ?? '') || '—')}</td>
      <td class="r">${r.poin}</td>
      <td>${wa62(r.wa ?? '')
        ? `<button class="btn ${r.hariIni ? 'primary' : ''}" style="padding:3px 10px" data-ut="${r.id}" data-w="${esc(wa62(r.wa ?? ''))}" data-n="${esc(r.nama)}" data-p="${r.poin}">🎂 Ucapkan</button>`
        : '<span style="font-size:11.5px;color:var(--danger)">No. WA kosong</span>'}</td></tr>`).join('')
    || `<tr><td colspan="5" class="empty">Tak ada pelanggan berulang tahun di ${esc(BLN[utBulan - 1] ?? '')}.</td></tr>`;

  host.innerHTML = `
    <div class="scope-note">Ucapan ulang tahun sekaligus mengingatkan poin yang bisa ditukar — alasan paling wajar untuk menyapa pelanggan yang lama tak datang. Tanggal lahir diisi di menu 👥 Pelanggan.</div>
    ${hariIni.length ? `<div class="scope-note" style="background:var(--okbg);color:var(--ok)">🎉 <b>${hariIni.length} pelanggan berulang tahun HARI INI</b>: ${esc(hariIni.map((r) => r.nama).join(', '))}</div>` : ''}
    <div class="toolbar" style="display:flex;gap:8px;align-items:center;margin:10px 0;flex-wrap:wrap">
      <label style="font-size:13px;color:var(--muted)">Bulan</label>
      <select id="ut_bln">${BLN.map((b, i) => `<option value="${i + 1}" ${utBulan === i + 1 ? 'selected' : ''}>${b}</option>`).join('')}</select>
      <span class="pill" style="background:var(--ice);color:var(--navy)">${rows.length} pelanggan</span>
      ${rows.filter((r) => wa62(r.wa ?? '')).length ? `<button class="btn" id="ut_all" style="margin-left:auto">📣 Kirim ke semua bulan ini</button>` : ''}
    </div>
    <table class="data"><thead><tr><th>Tanggal</th><th>Pelanggan</th><th>WhatsApp</th><th class="r">Poin</th><th>Aksi</th></tr></thead><tbody>${body}</tbody></table>`;

  const ulang = (): void => { void renderUltahTab(host); };
  host.querySelector('#ut_bln')?.addEventListener('change', (e) => { utBulan = +(e.target as HTMLSelectElement).value; ulang(); });
  host.querySelectorAll<HTMLElement>('button[data-ut]').forEach((b) => b.addEventListener('click', () =>
    void ucapkan(+(b.dataset['ut'] ?? 0), b.dataset['w'] ?? '', b.dataset['n'] ?? '', +(b.dataset['p'] ?? 0))));
  host.querySelector('#ut_all')?.addEventListener('click', () => ucapanMassal(rows.filter((r) => wa62(r.wa ?? ''))));
}

async function ucapkan(id: number, wa: string, nama: string, poin: number): Promise<void> {
  let link = '';
  try { link = `${location.origin}/poin.html#t=${await loyaltyRepo.tokenPoin(id)}`; } catch { /* tautan opsional */ }
  openWA(wa, fillTpl(waTpl().ultah, { nama, poin: String(poin), link }));
}

function ucapanMassal(list: BarisUt[]): void {
  const bg = openModal(`<div class="modal-head"><h3>🎂 Ucapan ulang tahun — ${list.length} pelanggan</h3><button class="x">×</button></div>
    <div class="modal-body">
      <div class="scope-note">Klik 🎂 per pelanggan. Yang berulang tahun <b>hari ini</b> ditandai di atas.</div>
      <div class="field"><label>Pesan</label><textarea id="ut_msg" rows="6">${esc(waTpl().ultah)}</textarea>
        <div class="hint">Isian otomatis: <b>{nama}</b> · <b>{poin}</b> · <b>{link}</b></div></div>
      <div style="max-height:38vh;overflow:auto">${list.map((r) => `<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--line);font-size:13px">
        <span>${r.hariIni ? '🎉 ' : ''}<b>${r.tgl}</b> · ${esc(r.nama)}<br><span style="color:var(--muted);font-size:11.5px">${r.poin} poin</span></span>
        <button class="btn" style="padding:2px 8px;flex:none" data-u="${r.id}" data-w="${esc(wa62(r.wa ?? ''))}" data-n="${esc(r.nama)}" data-p="${r.poin}">🎂</button></div>`).join('')}</div></div>
    <div class="modal-foot"><button class="btn" id="ut_tutup">Tutup</button></div>`);
  const msg = (): string => (bg.querySelector('#ut_msg') as HTMLTextAreaElement).value;
  bg.querySelector('#ut_tutup')?.addEventListener('click', () => bg.remove());
  bg.querySelectorAll<HTMLElement>('button[data-u]').forEach((b) => b.addEventListener('click', async () => {
    let link = '';
    try { link = `${location.origin}/poin.html#t=${await loyaltyRepo.tokenPoin(+(b.dataset['u'] ?? 0))}`; } catch { /* opsional */ }
    openWA(b.dataset['w'], fillTpl(msg(), { nama: b.dataset['n'] ?? '', poin: b.dataset['p'] ?? '0', link }));
  }));
}
